/* istanbul ignore file */
import { array as codecArray, number as codecNumber, optional as codecOptional, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RubricRowBaseInputAsJSON } from './RubricRowBaseInputAsJSON';
const PutRubricAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    [
        'maxPoints',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecNumber)),
        'max_points',
    ],
    [
        'rows',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(RubricRowBaseInputAsJSON)),
    ],
]);
export class PutRubricAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutRubricAssignmentDataParser.decode(input).map(res => new PutRubricAssignmentData(res));
    }
    static unsafeDecode(input) {
        return PutRubricAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutRubricAssignmentDataParser.encode(data);
    }
    static schema() {
        return PutRubricAssignmentDataParser.schema();
    }
}
